import { TReduxActions } from '../../types/redux';
import { IGeocodeState } from '../../types/redux/geocode';
import { EActionTypes } from '../../actions/geocode';

const initialState: IGeocodeState = {
  geocodeItems: [],
};

export const geocodeReducer = (state = initialState, action: TReduxActions): IGeocodeState => {
  switch (action.type) {
    case EActionTypes.GetGeocode:
      return {
        ...state,
        geocodeItems: action.payload.items ?? [],
      };

    default:
      return state;
  }
};
